import Model, { attr } from '@ember-data/model';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('growth')
class ContactModel extends Model {
  @attr('string') declare name: string;
  @attr('string') declare email: string;
  @attr('string') declare title: string;
}

export default ContactModel;

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    contact: ContactModel;
  }
}
